var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SubAPI } from "./SubAPI";
var CostingAPI = /** @class */ (function (_super) {
    __extends(CostingAPI, _super);
    function CostingAPI(key, api) {
        var _this = _super.call(this, api) || this;
        _this.key = void 0;
        _this.key = key;
        return _this;
    }
    CostingAPI.prototype.list = function (props) { return this.fetchPaginated("/api/costing/".concat(this.key, "/list"), props); };
    CostingAPI.prototype.remove = function (props) { return this.fetcher.post("/api/costing/".concat(this.key, "/remove"), props); };
    CostingAPI.prototype.insert = function (props) { return this.fetcher.post("/api/costing/".concat(this.key, "/create"), props); };
    CostingAPI.prototype.update = function (props) { return this.fetcher.post("/api/costing/".concat(this.key, "/update"), props); };
    CostingAPI.prototype.utm = function () { return this.fetcher.get("/api/costing/".concat(this.key, "/utm-list")); };
    CostingAPI.prototype.vendors = function () { return this.fetcher.get("/api/costing/".concat(this.key, "/vendor-list")); };
    return CostingAPI;
}(SubAPI));
export { CostingAPI };
